/**
 * For SIGN-IN users, mark onboarding as complete so they skip the profile wizard.
 * Called after OAuth / GIS succeeds when the user explicitly chose Sign In.
 *
 * IMPORTANT: Only marks complete for users who ALREADY have a profile row.
 * New/re-created accounts (no profile) must go through onboarding.
 */
import { supabase } from '../../lib/supabase';

export async function markOnboardingCompleteForSignin(userId: string): Promise<void> {
  try {
    // Check if this user already has a profile row
    const { data: existing } = await supabase
      .from('user_profiles')
      .select('id, onboarding_completed')
      .eq('id', userId)
      .maybeSingle();

    // No profile row → brand new user (or re-created account) → let onboarding run
    if (!existing) {
      console.info('[markOnboardingCompleteForSignin] No profile found — skipping (new user will see onboarding)');
      return;
    }

    // Already complete → nothing to do
    if (existing.onboarding_completed) return;

    // Existing profile but onboarding not flagged → mark complete (legacy user)
    const { error } = await supabase
      .from('user_profiles')
      .update({
        onboarding_completed: true,
        tour_completed: true,
      })
      .eq('id', userId);

    if (error) {
      console.warn('[markOnboardingCompleteForSignin] update failed:', error.message);
    }
  } catch (e) {
    console.warn('[markOnboardingCompleteForSignin] error:', e);
  }
}
